import React, { memo } from "react";
import { PerformerAboutWrapper } from "./style";

const KTPerformerAbout = memo(() => {
  return <PerformerAboutWrapper>KTArtistAbout</PerformerAboutWrapper>;
});

export default KTPerformerAbout;
